import styled from "styled-components";
import { colorPrimary, colorMain, colorBg, colorPrimaryAccent } from "./colors";

export const mobileMargin = "15px 0";
export const headerFont = "20px";

interface AppContainerProps {
  disabled?: boolean;
}

export const AppsWrapper = styled.div`
  padding: 25px 5%;
  width: 90%;

  @media (max-width: 600px) {
    padding: 25px 0;
    width: 100%;
  }
`;

export const AppContainer = styled.div<AppContainerProps>`
  pointer-events: ${(props) => (props?.disabled ? "none" : "auto")};
  opacity: ${(props) => (props?.disabled ? "0.35" : "1")};
  min-height: 600px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 25px 0;
`;

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  @media (max-width: 900px) {
    justify-content: center;
  }
`;

export const ContainerTile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: center;
  margin-top: 25px;
  min-width: 300px;

  @media (max-width: 1165px) {
    height: auto;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 0;
  flex-wrap: wrap;

  @media (max-width: 1000px) {
    justify-content: center;
    text-align: center;
    margin: 25px 0;
  }

  @media (max-width: 600px) {
    margin: ${mobileMargin};
  }
`;

interface WrapperProps {
  justify?: string;
  wrap?: boolean;
  gap?: string;
}

export const RowWrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) =>
    props?.justify ? props.justify : "space-around"};
  text-align: center;
  flex-wrap: ${(props) => (props?.wrap ? "wrap" : "nowrap")};
  gap: ${(props) => (props?.gap ? `${props.gap}` : `unset`)};
`;

interface ButtonProps {
  active?: boolean;
  width?: string;
  height?: string;
  fixedWidth?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: inline-block;
  background: ${colorBg};
  color: ${(props) => (props?.active ? `${colorPrimary}` : `${colorMain}`)};
  padding: 5px;
  font-size: 16px;
  border: 3px solid
    ${(props) => (props?.active ? `${colorPrimary}` : `${colorMain}`)};
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s ease-in;
  outline: none;
  margin: 0;
  height: ${(props) => (props?.height ? props.height : "auto")};
  width: ${(props) => (props?.width ? props.width : "100%")};

  @media (max-width: 600px) {
    width: ${(props) =>
      props?.fixedWidth && props.width ? props.width : "110px"};
    font-size: 12px;
  }

  @media (min-width: 600px) and (max-width: 1000px) {
    font-size: 16px;
  }

  &:hover,
  &:active,
  &:focus {
    background: ${colorBg};
    color: ${(props) => (props?.active ? `${colorPrimary}` : `${colorMain}`)};
  }
  &:active {
    transform: scale(0.98);
  }
`;

export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 10px;

  @media (max-width: 600px) {
    font-size: 12px;
  }
  @media (max-width: 1000px) {
    font-size: 14px;
  }
`;

interface SubTextProps {
  isActive?: boolean;
  textAlign?: "center" | "start";
}

export const SubText = styled.div<SubTextProps>`
  font-size: 18px;
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "inherit")};
  color: ${(props) => (props?.isActive ? colorPrimary : colorMain)};
  margin: ${mobileMargin};
  @media (max-width: 900px) {
    text-align: center;
    margin: 10px auto;
    font-size: 16px;
  }
`;

export const ConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  margin: 0;
  flex-wrap: nowrap;

  @media (max-width: 1400px) {
    justify-content: space-between;
  }

  @media (max-width: 1165px) {
    justify-content: center;
    text-align: center;
  }
`;

interface TabContainerProps {
  disabled?: boolean;
}

export const TabContainer = styled.div<TabContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  text-align: center;
  margin: auto;
  pointer-events: ${(props) => (props?.disabled ? "none" : "auto")};
  opacity: ${(props) => (props?.disabled ? "0.35" : "1")};
  background-color: ${colorBg};
`;

interface TabProps {
  isActive?: boolean;
}

export const Tab = styled.h1<TabProps>`
  color: ${colorMain};
  font-weight: ${(props) => (props?.isActive ? "bold" : "normal")};
  margin: 0;
  font-size: ${headerFont};
  line-height: 5rem;
  width: 100%;
  border-bottom: 2px solid ${colorMain};
  opacity: ${(props) => (props?.isActive ? 1 : 0.25)};

  &:hover {
    color: ${colorPrimary};
    cursor: pointer;
    opacity: 1;
    background-color: ${colorPrimaryAccent};
    border-bottom: 2px solid ${colorPrimary};
  }

  @media (max-width: 700px) {
    font-size: 1.1rem;
    line-height: 2.1rem;
  }

  @media (min-width: 700px) and (max-width: 1000px) {
    font-size: 18px;
    line-height: 2rem;
  }

  color: ${(props) => (props?.isActive ? colorPrimary : colorMain)};
  border-bottom: 2px solid
    ${(props) => (props?.isActive ? colorPrimary : colorMain)};
  line-height: 3.3rem;
  opacity: 1;
  background-color: ${colorBg};

  &:active {
    transform: scale(0.98);
  }
`;

interface HeaderProps {
  textAlign?: "center" | "start" | "end";
}
export const Header = styled.div<HeaderProps>`
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "center")};
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: ${headerFont};

  @media (min-width: 600px) and (max-width: 1000px) {
    text-align: center;
    margin: ${mobileMargin};
  }
  @media (max-width: 600px) {
    font-size: 1.5rem;
    margin: ${mobileMargin};
  }
`;

interface H1Props {
  bold?: boolean;
  textAlign?: "center" | "left";
}

export const H1 = styled.h1<H1Props>`
  margin: 20px 0;
  font-size: ${headerFont};
  font-weight: ${(props) => (props?.bold ? "bold" : "normal")};

  @media (max-width: 600px) {
    font-size: 1.3rem;
    margin: ${mobileMargin};
  }
`;

export const HeaderWithDisclaimerContainer = styled.span`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  wrap: nowrap;
`;

export const H1Summary = styled.h1<H1Props>`
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
  font-size: ${headerFont};
  margin: ${mobileMargin};

  @media (max-width: 1165px) {
    text-align: center;
  }

  @media (max-width: 600px) {
    font-size: 1.4rem;
  }
`;
